import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  linkTo?: string;
  onClick?: () => void;
  className?: string;
  showText?: boolean;
}

export const Logo = forwardRef<HTMLSpanElement, LogoProps>(
  ({ size = 'md', linkTo, onClick, className, showText = true }, ref) => {
    const sizeClasses = {
      sm: {
        text: 'text-lg',
        subtext: 'text-sm',
      },
      md: {
        text: 'text-2xl',
        subtext: 'text-lg',
      },
      lg: {
        text: 'text-3xl',
        subtext: 'text-xl',
      },
    };

    const logoContent = (
      <span ref={ref} className={cn("font-display tracking-tight flex items-center gap-1", className)}>
        <span className={cn("font-bold dark:drop-shadow-[0_0_10px_hsl(199,89%,48%,0.5)]", sizeClasses[size].text)}>
          <span className="text-electric-blue">big</span>
          <span className="text-electric-purple dark:text-white">E</span>
        </span>
        {showText && (
          <span className={cn("font-semibold bg-gradient-to-r from-electric-blue to-electric-purple bg-clip-text text-transparent translate-y-px relative", sizeClasses[size].subtext)}>
            sales coach<span className="absolute -top-0.5 -right-3 text-[0.8em] text-electric-purple">®</span>
          </span>
        )}
      </span>
    );

    if (linkTo) {
      return (
        <Link to={linkTo} className="hover:opacity-80 transition-opacity">
          {logoContent}
        </Link>
      );
    }

    if (onClick) {
      return (
        <button onClick={onClick} className="hover:opacity-80 transition-opacity">
          {logoContent}
        </button>
      );
    }

    return logoContent;
  }
);

Logo.displayName = 'Logo';
